import React from 'react';
import '../../../styles/global.css';
import { TeamDetailListing } from '../TeamCard/model';
import { StylableProp } from '../../../utils/stylable-prop';
import Heading from '../../controls/Heading';
import SubHeading from '../../controls/SubHeading';
import { BsFillStarFill } from '@react-icons/all-files/bs/BsFillStarFill';
import verified from '../../../assets/Icons/verifiedIcon.svg';
import nuIcon from '../../../assets/Icons/nuWhiteIcon.svg';
import VideoComponent from './VideoComponent';
import Feedback from '../Feedback';
import ImageComponent from './ImageComponent';
import TeamHeading from '../Heading';
interface TeamMemberProps {
  member: TeamDetailListing;
}
function index(props: StylableProp<TeamMemberProps>) {
  const memberlist = props?.member?.teamDetail[0];
  return (
    <div>
      <div className="mt-20 flex max-w-7xl flex-col gap-5 px-5 md:my-10 md:grid-cols-4 md:flex-row md:gap-3 lg:gap-5  lg:px-10 2xl:my-2">
        <div className="col-span-2 md:col-span-1">
          <ImageComponent ImageComponent={memberlist} />
        </div>
        <div className="col-span-2 md:col-span-3">
          <Heading
            text={<h1>{memberlist?.name}</h1>}
            className="px-0 pb-2 text-2xl sm:px-0 md:px-2"
          />
          <SubHeading
            text={memberlist?.role}
            className="px-0 py-2 text-base font-semibold sm:px-0 md:px-2 md:text-base lg:text-base"
          />
          <div className="flex flex-col items-start justify-start gap-4 px-2 py-2 md:flex-row md:items-center md:justify-start md:gap-4 md:px-0">
            {memberlist?.verified === true && (
              <h3
                className={`mb-0 flex items-center gap-1 overflow-hidden truncate text-base font-medium leading-none md:p-1 md:text-base lg:text-base lg:font-semibold`}
              >
                <img src={verified} alt="verified" /> Verified Agent
              </h3>
            )}
            {memberlist?.verified === true && (
              <div className="hidden rounded-full bg-blue text-xl md:block md:h-2 md:w-2" />
            )}
            <div className="flex items-center gap-2 md:justify-between">
              <span className=" text-sm text-gray-600">
                {memberlist?.reviews ? `(${memberlist?.reviews})  reviews` : ''}
              </span>
              <span className={'flex items-center gap-1 text-blue'}>
                {Array(5).fill(<BsFillStarFill className=" h-5 w-5 md:h-6 md:w-6" />)}
              </span>
            </div>
          </div>
          <TeamHeading
            text={'About'}
            className="px-0 pt-8 font-bold text-brand sm:px-0 sm:text-2xl sm:text-brand md:px-2 md:pt-2 md:text-2xl md:text-brand lg:text-2xl"
          />
          {/* <p className="p-2 py-5 text-textColor">{memberlist?.biography}</p> */}
          <div
            dangerouslySetInnerHTML={{ __html: memberlist?.content }}
            className="team_detail p-2 py-5"
          ></div>
          <div className="flex flex-col gap-4 border-b border-t border-gray-300 py-3 lg:flex-row lg:items-center lg:justify-between lg:gap-0">
            <div>
              <TeamHeading
                text={'Location'}
                className="px-0 text-2xl font-bold text-brand sm:px-0 sm:text-brand md:px-2 md:text-2xl md:text-brand lg:text-2xl"
              />
              <SubHeading
                text={memberlist?.location ? memberlist?.location : ''}
                className="px-0 text-base font-medium sm:px-0 md:px-2 md:text-base lg:text-base"
              />
            </div>
            <div className="mx-auto">
              <img src={nuIcon} alt="icon" className="mx-auto" />
            </div>
            <div>
              <TeamHeading
                text={'nuBorrow Member Since'}
                className={`px-0 text-2xl font-bold sm:px-0 md:px-2 ${
                  'text-textColor' && 'text-brand'
                } sm:text-brand md:text-2xl md:text-brand lg:text-2xl`}
              />
              <SubHeading
                text={memberlist?.joined}
                className="px-0 text-base font-medium sm:px-0 md:px-2 md:text-base lg:text-base"
              />
            </div>
          </div>

          <div className="mx-auto mb-2 mt-6 flex flex-wrap gap-2 py-2">
            {memberlist?.related_tags &&
              memberlist?.related_tags?.map((data, index: number) => (
                <p
                  className="col-auto truncate text-ellipsis rounded-full border border-brand p-1 px-7 text-brand"
                  key={index}
                >
                  {data?.tag}
                </p>
              ))}
          </div>
        </div>
      </div>
      <Feedback />
      <VideoComponent
        videoSrcURL={memberlist?.videoUrl}
        videoTitle={memberlist?.videoTitle}
        agent_email={memberlist?.email}
        agentName={memberlist?.name}
      />
    </div>
  );
}

export default index;
